import PropTypes from 'prop-types';

export const pendingQuoteStatePropType = PropTypes.shape({
  quoteExpirationDate: PropTypes.string,
  isDuplicatedDealerQuoteOrder: PropTypes.bool,
  serialNumber: PropTypes.string,
  dealerDocumentStatus: PropTypes.string,
  orderId: PropTypes.string,
  quoteDetailLink: PropTypes.string,
  quoteCreationDate: PropTypes.string,
  unformattedNetQuoteTotalAmount: PropTypes.string,
  formattedNetQuoteTotalAmount: PropTypes.string,
  modelNumber: PropTypes.string,
  quoteDocumentNumber: PropTypes.string,
  poNumber: PropTypes.string,
  quoteCreationDefaultFormatDate: PropTypes.string,
  quoteExpirationDefaultFormatDate: PropTypes.string,
  quoteItems: PropTypes.arrayOf(
    PropTypes.shape({
      quantity: PropTypes.string,
      partNumber: PropTypes.string
    })
  )
});

export const pendingQuotesSchemaPropType = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    columnType: PropTypes.string,
    isSortable: PropTypes.bool,
    dataType: PropTypes.string,
    sortType: PropTypes.string,
    className: PropTypes.string,
    width: PropTypes.string
  })
);

export const quotePropType = PropTypes.shape({
  expires: PropTypes.string,
  orderId: PropTypes.string,
  quoteDocumentNumber: PropTypes.string,
  formattedNetQuoteTotalAmount: PropTypes.string,
  poNumber: PropTypes.string,
  quoteCreationDefaultFormatDate: PropTypes.string,
  quoteCreationDate: PropTypes.string,
  quoteExpirationDate: PropTypes.string,
  serialNumber: PropTypes.string,
  modelNumber: PropTypes.string,
  quoteDetailLink: PropTypes.string,
  quoteItems: PropTypes.arrayOf(
    PropTypes.shape({
      partNumber: PropTypes.string,
      quantity: PropTypes.string
    })
  ),
  purchaseOrderInfo: { poNumber: '12345' }
});

export const arrayOfQuotesPropType = PropTypes.arrayOf(quotePropType);
